import React from 'react'
import Layout from '../layouts/layout'
import SEO from '../components/seo'
import { Link } from 'gatsby'

import TitleHeader from '../components/titleheader'
import Card from '../components/card'
import corpresponsibilityimage1 from '../assets/images/esg-lp/esg_environment_box_d.png'
import corpresponsibilityimage2 from '../assets/images/esg-lp/esg_social_box_d.png'
import corpresponsibilityimage3 from '../assets/images/esg-lp/esg_governance_box_d.png'
import esgPdf2024 from '../assets/images/TCP_SUS_IMPACT_2023.pdf'
import susAndImpact2023 from '../assets/images/TCP_SUS_IMPACT_2023.pdf'
import FY23_Disclosures from '../assets/images/esg_2021/FY23_Disclosures.pdf'
import esghpdk from '../assets/images/esg_2021/2024_dk_esg.jpg'
import esghpmb from '../assets/images/esg_2021/2024_mb_esg.jpg'
import esgPdf2023 from '../assets/images/TCP-2022-ESG-Report-Final.pdf'
import esgPdf2022 from '../assets/images/esgReport2021.pdf'
import esgPdf2021 from '../assets/images/esgReport2020.pdf'
import esgPdf from '../assets/images/2019_ESG_Annual_Progress_Report.pdf'
import { trackPageData, getPageDetails } from '../analytics'

class CorporateResponsibility extends React.PureComponent {
  constructor(props) {
    super(props)

    let dataManager = {
      pageDetails: {},
    }
    if (typeof window !== `undefined`) {
      if (window.dataManager) {
        dataManager = window.dataManager
      }
    }
    dataManager.pageDetails = getPageDetails()
  }

  componentDidMount() {
    trackPageData()
  }

  render() {
    return (
      <Layout>
        <SEO title="" />
        <div
          style={{
            position: `relative`,
          }}
          class="row"
        >
          <a href={`${esgPdf2024}`} target="_blank">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <TitleHeader
                image={esghpdk}
                mbheaderimage={esghpmb}
                title="SUSTAINABILITY &amp; SOCIAL RESPONSIBILITY"
                addClass="corporateTitle esgTitle "
              />
            </div>
          </a>
          <br />
        </div>

        <div class="row mb-4 mt-1 ">
          <div class="col-md-12 col-sm-12 col-xs-12 text-center">
            <div>
              <p>
                We are passionate about providing fashionable, high-quality
                products at a great value—while remaining conscious of the steps
                we can take each day to be a more sustainable business. Our
                vision is embodied in our commitment to protecting the future of
                our PLACE:
              </p>
              <div class="row justify-content-center">
                <div class="col-md-7 col-sm-12 col-xs-12">
                  <ul class="list-inline list-bullet text-left">
                    <li class="corp-inside">
                      Upholding our promise of Protecting Our PLACES
                    </li>
                    <li class="corp-inside">
                      Fulfilling our pledge to Caring for Our COMMUNITIES
                    </li>
                    <li class="corp-inside">
                      Ensuring we are Upholding Our PRINCIPLES
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-md-4 col-sm-12">
            <Link to="/environment">
              <Card
                image={corpresponsibilityimage1}
                title="Protecting Our PLACES"
                description=""
              ></Card>
            </Link>
          </div>

          <div class="col-md-4 col-sm-12">
            <Link to="/social">
              <Card
                image={corpresponsibilityimage2}
                title="Caring for Our COMMUNITIES"
                description=""
              ></Card>
            </Link>
          </div>

          <div class="row d-md-none mb-5" style={{ width: 100 }}></div>
          <div class="col-md-4 col-sm-12">
            <Link to="/governance">
              <Card
                image={corpresponsibilityimage3}
                title="Upholding Our PRINCIPLES"
                description=""
              ></Card>
            </Link>
          </div>
        </div>

        <div class="row justify-content-center">
          <p class="text-center">
            Learn more about our strategy and progress to date through our
            annual reports and updates
          </p>
        </div>
        <div class="row mb-5 justify-content-center" id="force-display">
          <p>
            <a target="_blank" href={`${susAndImpact2023}`}>
              2023 Impact Update{' '}
            </a>
            |
            <a target="_blank" href={`${FY23_Disclosures}`}>
              {' '}
              Disclosures
            </a>
          </p>
          <p>
            <a target="_blank" href={`${esgPdf2023}`}>
              2022 ESG Report{' '}
            </a>
            |{' '}
            <a
              target="_blank"
              href={`https://newsplace.childrensplace.com/the-childrens-place-issues-2022-annual-esg-report/`}
            >
              Press Releases
            </a>
          </p>
          <p>
            <a target="_blank" href={`${esgPdf2022}`}>
              2021 ESG Report
            </a>{' '}
            |{' '}
            <a
              target="_blank"
              href={`https://newsplace.childrensplace.com/the-childrens-place-issues-2021-annual-esg-report/`}
            >
              Press Releases
            </a>
          </p>
          <p>
            <a target="_blank" href={`${esgPdf2021}`}>
              2020 ESG Report
            </a>{' '}
            |{' '}
            <a
              target="_blank"
              href={`https://newsplace.childrensplace.com/the-childrens-place-issues-2020-annual-esg-report/`}
            >
              Press Releases
            </a>
          </p>
          <a target="_blank" href={`${esgPdf}`}>
            <p>2019 ESG Report</p>
          </a>
        </div>
      </Layout>
    )
  }
}

export default CorporateResponsibility
